<script setup>
import { ref } from 'vue'
import Portrait from '@/Shared/Portrait.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import ToggleInput from '@/Shared/ToggleInput.vue'

const form = ref({
  name: '',
  email: '',
  phone: ''
})

const toggles = ref({
  emailNotifications: false,
  shareUsageData: true,
  darkMode: false,
  autoSave: true
})

const isSubmitting = ref(false)

const submit = () => {
  isSubmitting.value = true
  // Simulación de envío
  setTimeout(() => {
    isSubmitting.value = false
    form.value = { name: '', email: '', phone: '' }
  }, 1500)
}

const breadcrumbs = [{ label: 'Ejemplos' }, { label: 'Portrait' }]
</script>

<template>
  <div class="space-y-8">
    <!-- Ejemplo básico -->
    <Portrait
      title="Información Personal"
      subtitle="Completa tu información de contacto"
      :breadcrumbs="breadcrumbs"
    >
      <form class="space-y-6" @submit.prevent="submit">
        <div>
          <label for="name" class="block text-sm font-medium text-gray-700">Nombre completo</label>
          <input
            id="name"
            v-model="form.name"
            type="text"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            placeholder="Tu nombre"
          />
        </div>

        <div>
          <label for="email" class="block text-sm font-medium text-gray-700"
            >Correo electrónico</label
          >
          <input
            id="email"
            v-model="form.email"
            type="email"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            placeholder="tu@email.com"
          />
        </div>

        <div>
          <label for="phone" class="block text-sm font-medium text-gray-700">Teléfono</label>
          <input
            id="phone"
            v-model="form.phone"
            type="tel"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            placeholder="+34 612 345 678"
          />
        </div>

        <div>
          <LoadingButton :loading="isSubmitting" type="submit" class="btn-indigo">
            Guardar información
          </LoadingButton>
        </div>
      </form>
    </Portrait>

    <!-- Ejemplo con footer actions -->
    <Portrait
      title="Configuración de Privacidad"
      subtitle="Gestiona tus preferencias de privacidad"
      :breadcrumbs="breadcrumbs"
      :footer-actions="true"
    >
      <div class="space-y-4">
        <ToggleInput
          v-model="toggles.emailNotifications"
          label="Notificaciones por email"
          description="Recibe actualizaciones sobre tu cuenta por email"
        />
        
        <ToggleInput
          v-model="toggles.shareUsageData"
          label="Compartir datos de uso"
          description="Ayúdanos a mejorar compartiendo datos anónimos de uso"
        />
        
        <ToggleInput
          v-model="toggles.darkMode"
          label="Modo oscuro"
          description="Cambia la apariencia de la aplicación a un tema oscuro"
        />
        
        <ToggleInput
          v-model="toggles.autoSave"
          label="Guardado automático"
          description="Guarda automáticamente los cambios mientras trabajas"
        />
        
        <div class="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h3 class="text-base font-medium text-gray-800 mb-2">Estado actual de los toggles:</h3>
          <pre class="text-sm text-gray-600 whitespace-pre-wrap">{{ JSON.stringify(toggles, null, 2) }}</pre>
        </div>
      </div>

      <template #footer>
        <div class="flex space-x-3">
          <button type="button" class="btn-white">Cancelar</button>
          <LoadingButton :loading="isSubmitting" class="btn-indigo">
            Guardar preferencias
          </LoadingButton>
        </div>
      </template>
    </Portrait>
  </div>
</template>

<style scoped>
.btn-indigo {
  @apply px-4 py-2 bg-indigo-600 text-white rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors;
}

.btn-white {
  @apply px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-md font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors;
}
</style>
